export default __webpack_public_path__ + "static/media/whiteArrowDown.1da3b4a5.svg";